import { render } from "./OpenExpensesTable.vue?vue&type=template&id=1da4a459&scoped=true"
import script from "./OpenExpensesTable.vue?vue&type=script&lang=js"
export * from "./OpenExpensesTable.vue?vue&type=script&lang=js"

import "./OpenExpensesTable.vue?vue&type=style&index=0&id=1da4a459&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da4a459"]])

export default __exports__